import { render } from "./Classroom.vue?vue&type=template&id=cdc3e57e"
import script from "./Classroom.vue?vue&type=script&lang=js"
export * from "./Classroom.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./Classroom.vue?vue&type=style&index=1&id=cdc3e57e&lang=css"

import exportComponent from "C:\\Users\\Usuario\\Documents\\frontCode\\GN-Students\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__